import angular from 'angular';
import uiRouter from 'angular-ui-router';
import foodBenefitDelegationsComponent from './foodBenefitDelegations.component';
import { ROUTES } from 'common/domain/routes';
import { STATES } from 'common/domain/states';

let foodBenefitDelegationsModule = angular.module('food-benefit.foodBenefitDelegations', [
  uiRouter,
])

.component('foodBenefitDelegations', foodBenefitDelegationsComponent)

.config(($stateProvider) => {
  'ngInject';

  $stateProvider
    .state(STATES.FOOD_BENEFIT.DELEGATE, {
      url: ROUTES.FOOD_BENEFIT.DELEGATE,
      component: 'foodBenefitDelegations',
      data: {
        requiresAuth: true,
      },
    });
})
.name;

export default foodBenefitDelegationsModule;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/features/foodBenefitDelegations/foodBenefitDelegations.js